module.exports = __webpack_public_path__ + "media/fr_fr_s4_Sophie.299d375b.mp3";